<template>
    <div>
        <el-form :inline="true" :model="searchForm" @submit.native.prevent>

            <el-form-item label="操作时间：" class="dateRange">
                <el-date-picker v-model="searchForm.time" range-separator="至" type="daterange" start-placeholder="开始日期"
                    end-placeholder="结束日期" value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
            <el-form-item class="btnArea">
                <el-button type="primary" @click="getListHandler($event)">搜索查询</el-button>
                <span>
                    <a class="export-tamplate" @click="exportHandle()">下载模板</a>
                </span>
            </el-form-item>

            <el-form-item class="btnArea">
                <el-button type="primary" @click="importCardVisible = true">批量修改卡状态</el-button>
            </el-form-item>
            <el-form-item class="btnArea">
                <el-button type="primary" @click="importCardVisible1 = true">批量修改卡单价</el-button>
            </el-form-item>
            <el-form-item class="btnArea">
                <el-button type="primary" @click="importCardVisible2 = true">批量修改卡备注</el-button>
            </el-form-item>
            <el-form-item class="btnArea">
                <el-button type="primary" @click="importCardVisible3 = true">修改运营商</el-button>
            </el-form-item>
            <el-form-item class="btnArea">
                <el-button type="primary" @click="importCardVisible4 = true">添加自定义套餐</el-button>
            </el-form-item>

            <el-form-item class="btnArea">
                <el-button type="primary" @click="importCardVisible5 = true">查询真实状态</el-button>
            </el-form-item>

            <el-form-item class="btnArea">
                <el-button type="primary" @click="importCardVisible6 = true">根据SN查询信息</el-button>
            </el-form-item>

            <el-form-item class="btnArea">
                <el-button type="primary" @click="importCardVisible7 = true">查询冻结状态</el-button>
            </el-form-item>
        </el-form>

        <el-table :data="tbpg.tableData" border height="611">
            <el-table-column type="index" label="序号" width="50"></el-table-column>
            <el-table-column prop="stateName" label="转为状态"></el-table-column>
            <el-table-column prop="total" label="总卡数"></el-table-column>
            <el-table-column prop="success" label="成功数"></el-table-column>
            <el-table-column label="失败数">
                <template slot-scope="scope">
                    <span style="color: red;">{{ scope.row.fail > 0 ? scope.row.fail : '' }}</span>
                </template>
            </el-table-column>
            <el-table-column label="操作时间" width="150">
                <template slot-scope="scope">
                    {{ dateFormat('yyyy-MM-dd hh:mm:ss', new Date(scope.row.createTime)) }}
                </template>
            </el-table-column>
            <el-table-column prop="remark" label="备注"></el-table-column>
            <el-table-column prop="disposeName" label="操作人"></el-table-column>
            <el-table-column label="操作" width="80">
                <template v-slot="scope">
                    <el-button v-if="scope.row.fail > 0" type="text" size="small"
                        @click="showFailCard(scope.row)">查看失败</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage" :page-sizes="[15, 50, 100, 500]" :page-size="tbpg.pageSize"
            layout="total, sizes, prev, pager, next, jumper" :total="tbpg.total">
        </el-pagination>
        <el-dialog title="批量修改卡备注" :visible.sync="importCardVisible2" width="600px" @close="cancel"
            :close-on-click-modal="false">
            <el-form ref="importCardForm" :model="importCardForm" label-width="100px">
                <el-form-item label="导入Excel：" prop="uploadExcel">
                    <el-upload ref="upload" :action="uploadUrl('sim/other/update/sn')" :headers="setHeader()"
                        :auto-upload="false" :data="importCardForm" :on-change="handleChange" :on-success="handleSuccess"
                        :file-list="fileList">
                        <el-button slot="trigger" plain>导入Excel</el-button>
                        <el-button style="margin-left: 10px;" plain @click="exportHandle2()">导出模板</el-button>
                    </el-upload>
                </el-form-item>
                <el-form-item label="备注：" width="80" prop="remark">
                    <el-input v-model="importCardForm.remark" clearable></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="sureImportCardHandle2">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="批量修改运营商" :visible.sync="importCardVisible3" width="600px" @close="cancel"
            :close-on-click-modal="false">
            <el-form ref="importCardForm" :model="importCardForm" label-width="100px">
                <el-form-item label="导入Excel：" prop="uploadExcel">
                    <el-upload ref="upload" :action="uploadUrl('sim/other/update/pkgs')" :headers="setHeader()"
                        :auto-upload="false" :data="importCardForm" :on-change="handleChange" :on-success="handleSuccess"
                        :file-list="fileList">
                        <el-button slot="trigger" plain>导入Excel</el-button>
                        <el-button style="margin-left: 10px;" plain @click="exportHandle2()">导出模板</el-button>
                    </el-upload>
                </el-form-item>
                <el-form-item label="运营商名称：">
                    <el-select v-model="importCardForm.supplierId" clearable>
                        <el-option v-for="item in supplierOption" :value="item.id" :key="item.id"
                            :label="item.supplierName"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="流量池（非必选）：">
                    <el-select v-model="importCardForm.simPoolId" filterable placeholder="请选择或输入关键字" clearable>
                        <el-option v-for="item in flowPoolOption" :value="item.id" :key="item.id"
                            :label="item.name"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="sureImportCardHandle3">确 定</el-button>
            </div>
        </el-dialog>

        <el-dialog title="添加自定义套餐" :visible.sync="importCardVisible4" width="600px" @close="cancel"
            :close-on-click-modal="false">
            <el-form ref="importCardForm" :model="importCardForm" label-width="100px">
                <el-form-item label="导入Excel：" prop="uploadExcel">
                    <el-upload ref="upload" :action="uploadUrl('sim/other/add/pkgs')" :headers="setHeader()"
                        :auto-upload="false" :data="importCardForm" :on-change="handleChange" :on-success="handleSuccess"
                        :file-list="fileList">
                        <el-button slot="trigger" plain>导入Excel</el-button>
                        <el-button style="margin-left: 10px;" plain @click="exportHandle2()">导出模板</el-button>
                    </el-upload>
                </el-form-item>

                <el-form-item label="自定义套餐组：" prop="agentId">
                    <el-select v-model="importCardForm.packageIdG" @change="changeAgentGroup" filterable
                        placeholder="请选择或输入关键字">
                        <el-option v-for="item in packageOption" :value="item.id" :key="item.id"
                            :label="item.name"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="套餐规格套餐：" prop="agentId">
                    <el-select v-model="importCardForm.packageId" filterable placeholder="请选择或输入关键字">
                        <el-option v-for="item in pkgsOption" :value="item.id" :key="item.id"
                            :label="item.name"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="sureImportCardHandle4">确 定</el-button>
            </div>
        </el-dialog>

        <el-dialog title="批量修改卡状态" :visible.sync="importCardVisible" width="600px" @close="cancel"
            :close-on-click-modal="false">
            <el-form ref="importCardForm" :model="importCardForm" :rules="importCardRules" label-width="100px">
                <el-form-item label="导入Excel：" prop="uploadExcel">
                    <el-upload ref="upload" :action="uploadUrl('sim/batch/upate/sim')" :headers="setHeader()"
                        :auto-upload="false" :data="importCardForm" :on-change="handleChange" :on-success="handleSuccess"
                        :file-list="fileList">
                        <el-button slot="trigger" plain>导入Excel</el-button>
                        <el-button style="margin-left: 10px;" plain @click="exportHandle()">导出模板</el-button>
                    </el-upload>
                </el-form-item>
                <el-form-item label="卡状态：" width="80" prop="states">
                    <el-select v-model="importCardForm.states" clearable>
                        <el-option value="1" label="沉默期"></el-option>
                        <el-option value="2" label="正常"></el-option>
                        <el-option value="3" label="停机"></el-option>
                        <el-option value="4" label="测试期"></el-option>
                        <el-option value="44" label="过期"></el-option>
                        <el-option value="55" label="注销"></el-option>
                        <el-option value="20" label="其他"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="备注：" width="80" prop="remark">
                    <el-input v-model="importCardForm.remark" clearable></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="sureImportCardHandle">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="批量修改卡单价" :visible.sync="importCardVisible1" width="600px" @close="cancel"
            :close-on-click-modal="false">
            <el-form ref="importCardForm" :model="importCardForm" :rules="importCardRules" label-width="100px">
                <el-form-item label="导入Excel：" prop="uploadExcel">
                    <el-upload ref="upload" :action="uploadUrl('sim/batch/upate/sim/price')" :headers="setHeader()"
                        :auto-upload="false" :data="importCardForm" :on-change="handleChange" :on-success="handleSuccess"
                        :file-list="fileList">
                        <el-button slot="trigger" plain>导入Excel</el-button>
                        <el-button style="margin-left: 10px;" plain @click="exportHandle1()">导出模板</el-button>
                    </el-upload>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="sureImportCardHandle">确 定</el-button>
            </div>
        </el-dialog>



        <el-dialog title="批量修改卡状态" :visible.sync="failCardVisible" width="70%" height="70%" :close-on-click-modal="false">
            <el-table :data="failCardData" style="width: 100%">
                <el-table-column type="index" label="序号" width="50"> </el-table-column>
                <el-table-column prop="intoNo" label="接入号" width="180"> </el-table-column>
                <el-table-column prop="remark" label="备注"></el-table-column>
            </el-table>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="failCardVisible = false">确 定</el-button>
            </div>
        </el-dialog>



        <el-dialog title="查询卡真实状态" :visible.sync="importCardVisible5" width="600px" @close="cancel"
            :close-on-click-modal="false">
            <el-form ref="importCardForm" :model="importCardForm" label-width="100px">
                <el-form-item label="导入Excel：" prop="uploadExcel">
                    <el-upload ref="upload" :action="uploadUrl('excels/import/real/state/excel')" :headers="setHeader()"
                        :auto-upload="false" :data="importCardForm" :on-change="handleChange" :on-success="handleSuccess"
                        :file-list="fileList">
                        <el-button slot="trigger" plain>导入Excel</el-button>
                        <el-button style="margin-left: 10px;" plain @click="exportHandle2()">导出模板</el-button>
                    </el-upload>
                </el-form-item>
                <el-form-item label="下载名称：" width="80" prop="remark">
                    <el-input v-model="importCardForm.name" clearable></el-input>
                </el-form-item>
            </el-form> 
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="sureImportCardHandle5">确 定</el-button>
            </div>
        </el-dialog>

        <el-dialog title="根据SN查询" :visible.sync="importCardVisible6" width="600px" @close="cancel"
            :close-on-click-modal="false">
            <el-form ref="importCardForm" :model="importCardForm" label-width="100px">
                <el-form-item label="导入Excel：" prop="uploadExcel">
                    <el-upload ref="upload" :action="uploadUrl('excels/import/sn/excel')" :headers="setHeader()"
                        :auto-upload="false" :data="importCardForm" :on-change="handleChange" :on-success="handleSuccess"
                        :file-list="fileList">
                        <el-button slot="trigger" plain>导入Excel</el-button>
                        <el-button style="margin-left: 10px;" plain @click="exportHandle2()">导出模板</el-button>
                    </el-upload>
                </el-form-item>
                <el-form-item label="下载名称：" width="80" prop="remark">
                    <el-input v-model="importCardForm.name" clearable></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="sureImportCardHandle6">确 定</el-button>
            </div>
        </el-dialog>



        <el-dialog title="根据冻结查询" :visible.sync="importCardVisible7" width="600px" @close="importCardVisible7=false"
            :close-on-click-modal="false">
            <p style="color: red;">导入完成后 请稍后在下载中心进行下载数据</p>
            <el-form ref="importCardForm" :model="importCardForm" label-width="100px">
                <el-form-item label="导入Excel：" prop="uploadExcel">
                    <el-upload ref="upload" :action="uploadUrl('excels/import/dong/state/excel')" :headers="setHeader()"
                        :auto-upload="false" :data="importCardForm" :on-change="handleChange" :on-success="handleSuccess"
                        :file-list="fileList">
                        <el-button slot="trigger" plain>导入Excel</el-button>
                        <el-button style="margin-left: 10px;" plain @click="exportHandle2()">导出模板</el-button>
                    </el-upload>
                </el-form-item>
                <el-form-item label="下载名称：" width="80" prop="remark">
                    <el-input v-model="importCardForm.name" clearable></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="importCardVisible7=false">取 消</el-button>
                <el-button type="primary" @click="sureImportCardHandle7">确 定</el-button>
            </div>
        </el-dialog>



    </div>
</template>

<script>
import { getPkgListPage, addPkg, updatePkg, getPkgDetail, changePkgState, adminPkgSort } from '@/api/package.js'
import common from '@/utils/common.js'
export default {
    data() {
        var checkImportFile = (rule, value, callback) => {
            var files = this.$refs.upload.uploadFiles
            var len = files.length;
            if (len > 0) {
                var extName = files[0].name.split('.')[1].toLowerCase();
                if (extName != 'xls' && extName != 'xlsx') {
                    return callback(new Error('请选择要导入的Excel文件'));
                } else {
                    callback();
                }
            } else {
                return callback(new Error('请选择要导入的Excel文件'))
            }
        }
        return {
            flowPoolOption: [],
            supplierOption: [],//运营商名称列表
            searchForm: {
                time: null,
            },
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0
            },

            failCardVisible: false,
            failCardData: [],

            importCardForm: {
                states: null,
                remark: null,
                name:'',
                packageId: '',
                simPoolId: '',
                supplierId: ''
            },
            fileList: [],
            packageOption: [],
            pkgsOption: [],

            importCardVisible: false,
            importCardVisible1: false,
            importCardVisible2: false,
            importCardVisible3: false,
            importCardVisible4: false,
            importCardVisible5: false,
            importCardVisible6: false,
            importCardVisible7: false,
            importCardRules: {
                uploadExcel: [{ required: true, validator: checkImportFile }],
                states: [{ required: true, message: '请选择卡状态', trigger: 'change' }],
                remark: [{ required: true, message: '请填写备注', trigger: 'change' }]
            }
        }
    },
    methods: {
        //获取流量池
        getFlowPool() {
            common.sysRequest('simPool/list', { agentId: null }, 'post').then(res => {
                if (res.data.code == 200) {
                    for (let key in res.data.data) {
                        this.flowPoolOption.push({ id: key, name: res.data.data[key] })
                    }
                } else {
                    this.$message.error(res.data.message);
                }
            })
        },
        changeAgentGroup() {
            var voicePkg = {
                typeGroupId: this.importCardForm.packageIdG,
                isVoice: 0,
                perPageNum: 50
            }
            getPkgListPage(voicePkg).then(res => {
                this.pkgsOption = res.data.data.resultList;
                console.log(this.pkgsOption)
            })
        },
        /**  列表数据搜索  **/
        getListHandler($event) {
            common.resetCurrentPage(this, $event, 'tbpg');
            let data = common.getRequestParams(this, 'tbpg', this.searchForm);
            common.sysRequest('sim/batch/upate/list', data, 'post').then(res => {
                common.listCallback(this, res, 'tbpg');
            })
        },

        handleSizeChange(val) {
            this.tbpg.pageSize = val;
            this.getListHandler(this.$event);
        },
        handleCurrentChange(val) {
            this.tbpg.currentPage = val;
            this.getListHandler(this.$event);
        },

        handleChange(file, fileList) {
            if (fileList.length > 1) {
                fileList.splice(0, 1);
            }

        },
        /**  列表数据搜索  end **/

        //导出excel文件
        exportHandle() {
            this.exportExcel('/excel/sim/update', {});
            this.$message.success('下载中……');
        },
        exportHandle2() {
            this.exportExcel('/excel/sim/update/sn', {});
            this.$message.success('下载中……');
        },
        //导出excel文件
        exportHandle1() {
            this.exportExcel('/excel/sim/update/price', {});
            this.$message.success('下载中……');
        },
        //导出excel文件  end



        //批量修改卡状态  excel导入
        handleChange(file, fileList) {
            if (fileList.length > 1) {
                fileList.splice(0, 1);
            }
            this.$refs.importCardForm.fields[0].clearValidate();
            console.log(this.fileList);
        },
        handleSuccess(res) {
            if (res.code == 200) {
                this.getListHandler();

                this.$message.success(res.data);
            } else {
                this.$message.error(res.message);
            }
            this.importCardVisible = false;
        },

        sureImportCardHandle() {
            this.$refs.importCardForm.validate(valid => {
                if (valid) {
                    this.$refs.upload.submit();   //号段批量导入
                }
            })
        },
        sureImportCardHandle2() {
            this.$refs.importCardForm.validate(valid => {
                if (valid) {
                    this.$refs.upload.submit();   //号段批量导入
                }
            })
        },
        sureImportCardHandle5() {
            this.$refs.importCardForm.validate(valid => {
                if (valid) {
                    this.$refs.upload.submit();   //号段批量导入
                }
            })
        },
        sureImportCardHandle6() {
            this.$refs.importCardForm.validate(valid => {
                if (valid) {
                    this.$refs.upload.submit();   //号段批量导入
                }
            })
        },
        sureImportCardHandle7() {
            this.$refs.importCardForm.validate(valid => {
                if (valid) {
                    this.$refs.upload.submit();   //号段批量导入
                }
            })
        },
        sureImportCardHandle3() {
            this.$refs.importCardForm.validate(valid => {
                if (valid) {
                    this.$refs.upload.submit();   //号段批量导入
                }
            })
        },
        sureImportCardHandle4() {
            this.$refs.importCardForm.validate(valid => {
                if (valid) {
                    this.$refs.upload.submit();   //号段批量导入
                }
            })
        },
        cancel() {
            this.fileList.pop();
            this.importCardForm.states = null;
            this.importCardVisible = false;
            this.importCardVisible1 = false;
            this.importCardVisible2 = false;
            this.importCardVisible3 = false;
            this.importCardVisible4 = false;
            this.importCardVisible5 = false;
            this.importCardVisible6 = false;
        },

        //批量修改卡状态  excel导入  end 


        //查看失败
        showFailCard(row) {
            let newArray = [];
            let failCards = row.failIntono.split('_');
            for (let i = 0; i < failCards.length; i++) {
                newArray.push({
                    intoNo: failCards[i],
                    remark: row.failRemark
                });
            }
            this.failCardData = newArray;
            this.failCardVisible = true;
        },

    },
    created() {
        common.getSupplierOptsCom(this, 'supplierOption');
        this.getFlowPool();
        common.getPackageOptsCom(this, 'packageOption')
        this.getListHandler(this.$event);
    }
}
</script>

<style lang="scss" scoped>
.export-tamplate {
    box-sizing: border-box;
    border: 1px solid #dcdfe6;
    border-radius: 3px;
    width: 85px;
    height: 32px;
    display: inline-block;
    text-align: center;
    vertical-align: baseline;
    margin-left: 10px;
    font-size: 13px;
    color: #606266;
}

.export-tamplate:hover {
    color: #409EFF;
    border-color: #409EFF;
    transition: .3s;
}

.uploadUrl {
    box-sizing: border-box;
    border-radius: 3px;
    width: 180px;
    height: 64px;
    display: inline-block;
    vertical-align: baseline;
    margin-left: 10px;
    font-size: 13px;
    color: #606266;
}</style>

